import React, { PureComponent } from 'react'
// import { Grid } from 'react-bootstrap'

class AccessReset extends PureComponent {
  render () {
    return (
      <div className="bg-auth-reset-password _nf bg-auth">

        {this.props.children}

      </div>
    )
  }
}
export default AccessReset
